class MapHelper {

  getDistanceFromLatLonInKm(obj1, obj2) {
    var lat1 = obj1.lat;
    var lon1 = obj1.lng;
    var lat2 = obj2.lat;
    var lon2 = obj2.lng;

    var R = 6371; // Radius of the earth in km
    var dLat = this.deg2rad(lat2 - lat1);  // deg2rad below
    var dLon = this.deg2rad(lon2 - lon1);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.deg2rad(lat1)) * Math.cos(this.deg2rad(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2)
      ;
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c; // Distance in km
    return d;
  }

  deg2rad(deg) {
    return deg * (Math.PI / 180)
  }

  getZoomForTwoMarkers(marker1, marker2) {
    var kmDistance = this.getDistanceFromLatLonInKm(marker1, marker2);
    var zoom = 15;
    if (kmDistance <= 2) {
      zoom = 14;
    }
    if (kmDistance > 2 && kmDistance <= 3) {
      zoom = 13;
    }
    if (kmDistance > 3 && kmDistance <= 5) {
      zoom = 12;
    }
    if (kmDistance > 5 && kmDistance <= 15) {
      zoom = 11;
    }
    if (kmDistance > 15 && kmDistance <= 25) {
      zoom = 10;
    }
    if (kmDistance > 25) {
      zoom = 9;
    }
    return zoom;
  }

}

export default MapHelper;
